module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('div', [(_vm.order.canOrderUpdate && !_vm.order.canceled) ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.ModalEditOrder",
      modifiers: {
        "ModalEditOrder": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "title": "Изменить заказ"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.initEditOrder($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), (_vm.order.canOrderDelete) ? _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "title": "Удалить заказ"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.removeOrder()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-63a13a04"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderActions.vue
// module id = 1042
// module chunks = 1